module.exports = __webpack_public_path__ + "static/img/fuwu.3232a9f6.png";